module.exports = __webpack_public_path__ + "static/media/profile.caebd334.webp";